import React from 'react';
import { IconSize, VdsIcon } from '@el8/vital';
import { logEvent } from 'utils/amplitude';
import { NavbarItem } from '../../components/NavbarItem';
import styles from './WhatsNewNavItem.less';

const openResourceCenter = (): void => {
  window.userpilot?.trigger('resource_center:oclg1obXAY', { tab: 'news' });
  window.userpilotRC?.tab('news');
};

export const WhatsNewNavItem = (): JSX.Element | null => {
  if (!el8Globals.FEATURES.UPResourceCenterLink) {
    return null;
  }

  const handleClick = (): void => {
    logEvent('open: navigation whats new');
    openResourceCenter();
  };

  return (
    <NavbarItem
      aria-label="See What's New"
      data-testid="navbar-whats-new-button"
      icon={
        <VdsIcon
          icon="notifications"
          size={IconSize.XSmall}
          className={styles.bellIcon}
          data-testid="navbar-whats-new-icon"
        />
      }
      iconOnly
      onClick={handleClick}
      tooltip="See What's New"
      type="button"
    />
  );
};
